// The web app's "this traveller has seen the onboarding" flag.
//
// The gate is the ABSENCE of the flag — deliberately not a "first visit" signal — so people who
// already use the app see the carousel once too, which is the whole point of it. The key carries
// the content version (see Online::Apps::OnboardingHelper#onboarding_seen_storage_key), so bumping
// that version re-shows a redesigned carousel to everyone.
//
// This flag governs the web surface only. Each native app keeps its own equivalent flag, because
// the decision to show the carousel is made at launch, before any webview exists. The two never
// need to agree.

export function hasSeenOnboarding(storageKey) {
    if (!storageKey) return true;
    try {
        return !!window.localStorage.getItem(storageKey);
    } catch (error) {
        // Storage is blocked (private browsing, embedded contexts). We can't remember a dismissal,
        // so treat the carousel as seen rather than greeting the same person on every page load.
        return true;
    }
}

export function markOnboardingSeen(storageKey) {
    if (!storageKey) return;
    try {
        window.localStorage.setItem(storageKey, new Date().toISOString());
    } catch (error) {
        console.warn('[Onboarding] Could not record that the onboarding was seen', error);
    }
}
